import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot,
         CanActivate,
         Router, 
         RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../_services';

@Injectable({ providedIn: 'root' })
export class authGuard implements CanActivate {

  constructor(private authenticationService: AuthenticationService, private router: Router){};


  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot):boolean {
      console.log('CanActivate called');


      
      const currentUser = this.authenticationService.currentUserValue;

      this.authenticationService.loggedUser = false;
      console.log(currentUser)
      if (currentUser) {
        this.authenticationService.loggedUser = true;
        this.authenticationService.startTokenTimer();
        return true;
      }

      this.authenticationService.loggedUser = false;
      var logOut_URL = sessionStorage.getItem('LoginType');
      this.authenticationService.logout();
      this.router.navigateByUrl("login?type=" + (logOut_URL ? logOut_URL : 'patient')).then(() => {
        window.location.reload();
      });
      return false;
  }


}

